import React from 'react';
import { useVerificationWizard } from '../useVerificationWizard';
import OperatingHoursForm from '../../wizard/forms/OperatingHoursForm';
import VerificationStepActionBar from '../VerificationStepActionBar';
import { VERIFICATION_STEPS } from '../../../types/verification';

const STEP = VERIFICATION_STEPS.OPERATING_HOURS;

const VerifyOperatingHoursStep: React.FC = () => {
  const {
    state,
    stepErrors,
    updateOperatingHour,
    copyHoursToWeekdays,
    saveOperatingHours,
    markStepConfirmed,
    markStepSkipped,
    getStepStatus,
    isSaving,
    hasHoursOnRecord,
    applyStandardHours,
  } = useVerificationWizard();

  const errors = stepErrors[STEP] || {};

  return (
    <div className="wizard-step">
      <h2>Verify Operating Hours</h2>
      <p className="step-description">Review and update the clinic's operating hours.</p>

      {/* SLV2-3155: never present invented hours as the clinic's data. When
          nothing is on record, say so — the template is an explicit action. */}
      {!hasHoursOnRecord && (
        <div className="hours-no-record-notice">
          <p>
            <strong>No hours on record</strong> — operating hours have never been entered for
            this clinic. Enter the hours confirmed with the clinic, or start from the standard
            template and adjust.
          </p>
          <button
            type="button"
            className="btn-standard-hours"
            onClick={applyStandardHours}
            disabled={isSaving}
          >
            Start from standard hours (Mon&ndash;Fri, 8:00 AM&ndash;5:00 PM)
          </button>
        </div>
      )}

      <OperatingHoursForm
        hours={state.operatingHours}
        onUpdateHour={updateOperatingHour}
        onCopyToWeekdays={copyHoursToWeekdays}
        errors={errors}
      />

      <VerificationStepActionBar
        stepStatus={getStepStatus(STEP)}
        isSaving={isSaving}
        onSaveChanges={saveOperatingHours}
        onNoChanges={() => markStepConfirmed(STEP)}
        onSkip={(notes) => markStepSkipped(STEP, notes)}
      />
    </div>
  );
};

export default VerifyOperatingHoursStep;
